import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type SidebarState = 'expanded' | 'collapsed' | 'invisible';

interface SidebarContextType {
  sidebarState: SidebarState;
  setSidebarState: (state: SidebarState) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarState, setSidebarState] = useState<SidebarState>('expanded');

  return (
    <SidebarContext.Provider value={{ sidebarState, setSidebarState }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const useSidebarEffect = (state: SidebarState) => {
  const { setSidebarState } = useSidebar();

  useEffect(() => {
    setSidebarState(state);
    // Reset to expanded on unmount (NOTE: when we have Settings, we can remove this if we want to persist state)
    return () => {
      setSidebarState('expanded');
    };
  }, [state, setSidebarState]);
};
